// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__38QnW","noInteraction":"EventWrapper_noInteraction__30h-y"};